/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2021-01-27 17:46:00
 * @LastEditors: Sam
 * @Description: 
 * @FilePath: \tofba-client\src\main.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ExTableColumn from 'ex-table-column'
import '@/styles/index.scss' // global css
import i18n from './lang'
import App from './App'
import store from './store'
import router from './router'
import '@/icons/index' // icon
import '@/permission' // permission control
import 'handsontable/dist/handsontable.full.css'
Vue.config.devtools = true;
window.tips = function(params) {
  alert('asdf')
}

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component(ExTableColumn.name, ExTableColumn)
// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
